const IconPadlock = function () {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-padlock" viewBox="0 0 30 30"><path d="M15 2c-3.854334 0-7 3.1456661-7 7v2H6c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h18c1.105 0 2-.895 2-2V13c0-1.105-.895-2-2-2h-2V9c0-3.7284177-2.963419-6.7314347-6.644531-6.9277344A1.0001 1.0001 0 0 0 15 2zm0 2c2.773666 0 5 2.2263339 5 5v2H10V9c0-2.7736661 2.226334-5 5-5z"/></svg>
	)
}

export default IconPadlock;